import { ReactElement } from 'react';

import { LoadingButton as Button } from '@mui/lab';
import { Stack } from '@mui/material';

import { ActionsProps } from './types';

import LoginButton from '../../../../../../../../components/LoginButton';

export default function Actions(props: ActionsProps): ReactElement {
  const {
    loginOpen = false,
    hasFunMode = true,
    hasRealMode = true,
    loading = false,
    onClick,
    onSuccess,
    onSetModal
  } = props;

  return (
    <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
      {hasFunMode ? (
        <Button color='info' disabled={loading} onClick={() => onClick('fun')} variant='contained'>
          Fun
        </Button>
      ) : null}

      {hasRealMode ? (
        <LoginButton
          open={loginOpen}
          color='primary'
          loading={loading}
          onClick={(values) => onClick('real', values)}
          onSuccess={onSuccess}
          onSetModal={onSetModal}
          variant='contained'>
          Play
        </LoginButton>
      ) : null}
    </Stack>
  );
}
